import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@systemeio/ui';
import ContactFilterAddButton from 'modules/contacts/components/contact-filter-add-button';
import ContactFilterSkeleton from 'modules/contacts/components/contact-filter-skeleton';
import { ContactSearchFieldEnum } from 'modules/contacts/enums/contact-enum';
import { ContactFilterType } from 'modules/contacts/types/contact-filter-interface';
import { isFilterFiledEmpty } from 'modules/contacts/utils/is-filter-filed-empty';
import React, { useEffect, useState, type JSX } from 'react';
import { twMerge } from 'tailwind-merge';
interface ContactFilterWrapperProps {
  isFetching: boolean;
  lastElement?: boolean;
  children: JSX.Element;
  title: string;
  slug: string;
  addFilter: (slug: string) => void;
  clearClosingState: () => void;
  needToCloseFilters: boolean;
  clearFilterField: (slug: string) => void;
  filter: ContactFilterType;
}
export const ContactFilterWrapper = t0 => {
  const $ = _c(24);
  const {
    clearClosingState,
    needToCloseFilters,
    clearFilterField,
    isFetching,
    lastElement,
    children,
    filter,
    slug,
    addFilter,
    title
  } = t0;
  let t1;
  if ($[0] !== filter || $[1] !== slug) {
    t1 = isFilterFiledEmpty({
      filter,
      slug
    });
    $[0] = filter;
    $[1] = slug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [opened, setOpened] = useState(!t1);
  let t2;
  let t3;
  if ($[3] !== clearClosingState || $[4] !== clearFilterField || $[5] !== opened || $[6] !== slug) {
    t2 = () => {
      if (!opened) {
        clearFilterField(slug);
      } else {
        clearClosingState();
      }
    };
    t3 = [clearClosingState, clearFilterField, opened, slug];
    $[3] = clearClosingState;
    $[4] = clearFilterField;
    $[5] = opened;
    $[6] = slug;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] !== needToCloseFilters) {
    t4 = () => {
      if (needToCloseFilters) {
        setOpened(false);
      }
    };
    t5 = [needToCloseFilters];
    $[9] = needToCloseFilters;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] !== filter || $[13] !== slug) {
    t6 = () => {
      if (!isFilterFiledEmpty({
        filter,
        slug
      })) {
        setOpened(true);
      }
    };
    t7 = [filter, slug];
    $[12] = filter;
    $[13] = slug;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== addFilter || $[17] !== children || $[18] !== isFetching || $[19] !== lastElement || $[20] !== opened || $[21] !== slug || $[22] !== title) {
    t8 = isFetching ? <ContactFilterSkeleton isLast={lastElement || false} /> : <div className={twMerge(!lastElement && "border-b-text-secondary/30 border-b pb-3", "w-full px-4")}><div className="flex items-center gap-3"><div className="flex w-full flex-col gap-3"><div className="flex cursor-pointer justify-between gap-3" onClick={() => setOpened(!opened)}><span className={`${opened && "text-text-primary"} main-transition-colors truncate ${opened ? "font-semibold" : "font-normal"}`}>{title}</span><Checkbox className="pointer-events-none" value={opened} onChange={value => setOpened(value)} /></div>{opened && <>{children}{slug !== ContactSearchFieldEnum.affiliate && <ContactFilterAddButton onClick={e => {
              e.preventDefault();
              addFilter(slug);
            }} />}</>}</div></div></div>;
    $[16] = addFilter;
    $[17] = children;
    $[18] = isFetching;
    $[19] = lastElement;
    $[20] = opened;
    $[21] = slug;
    $[22] = title;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default ContactFilterWrapper;